<mat-card>{{'categories' | translate}}</mat-card>


<div class="container" style="padding: 25px;">

    <mat-grid-list cols="5" rowHeight="50px">

        <mat-grid-tile cols="2">
            <mat-form-field appearance="standard">
                <mat-label>{{'filter' | translate}}</mat-label>
                <input matInput (keyup)="applyFilter($event)" placeholder="Ex. Mia" #input>
            </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile></mat-grid-tile>
        <mat-grid-tile></mat-grid-tile>
        <mat-grid-tile></mat-grid-tile>


        <mat-grid-tile>
            <mat-form-field appearance="standard">
                <mat-label>{{'categoryStatus' | translate}}</mat-label>
                <mat-select [(value)]="selectedStatus" (selectionChange)="selectChange()">
                    <mat-option *ngFor="let status of Catgstatus" [value]="status.id">
                        {{status.name}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </mat-grid-tile>

    </mat-grid-list>

    <div class="mat-elevation-z8">
        <table mat-table [dataSource]="dataSource" matSort>

            <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'id' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.id}} </td>
            </ng-container>

            <ng-container matColumnDef="arabicName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'arabicName' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.aDesc}} </td>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="englishName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'englishName' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.eDesc}} </td>
            </ng-container>

            <!-- <ng-container matColumnDef="imageUrl">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'image' | translate}} </th>
        <td mat-cell *matCellDef="let row">
          <img src="{{row.pytic != 1 ? imagPath + row.imageUrl : row.imageUrl}}" alt="no image" width="80">
        </td>
      </ng-container> -->

            <ng-container matColumnDef="edit">
                <th mat-header-cell *matHeaderCellDef> {{'edit' | translate}} </th>
                <td mat-cell *matCellDef="let row">
                    <button mat-icon-button (click)="edit(row.id)">
                        <mat-icon>edit</mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">{{'noDataMatchingTheFilter' | translate}} "{{input.value}}"</td>
            </tr>
        </table>

        <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
    </div>

</div>

<app-matspinner dir="rtl" [overlay]="spinnerOverlay"></app-matspinner>